/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodDetailContract} from '../../../api/contracts/period/period-detail.contract';
import {PeriodDetailModel} from './period-detail.model';
import {PeriodSpecBaseMapper} from '../period-spec-detail/period-spec-base.mapper';
import {BundleDetailMapper} from '../../bundle/bundle-detail/bundle-detail.mapper';
import {TimePeriodBaseMapper} from '../time-period-base/time-period-base.mapper';
import {ReferenceDataMapper} from '../../reference-data/reference-data.mapper';
import {PeriodBundlesStatusSummaryMapper} from '../period-bundles-status-summary/period-bundles-status-summary.mapper';

export class PeriodDetailMapper {

    static fromPeriodDetailContractArray(input: PeriodDetailContract[], timezone?: string): PeriodDetailModel[] {
        return input?.map((element) => PeriodDetailMapper.fromPeriodDetailContract(element, timezone));
    }

    static fromPeriodDetailContract(input: PeriodDetailContract, timezone?: string): PeriodDetailModel {
        let model: PeriodDetailModel;

        if (input != null) {
            model = {
                code: input.code,
                spec: PeriodSpecBaseMapper.fromPeriodSpecBaseContract(input.spec),
                bundlesList: BundleDetailMapper.fromBundleDetailContractArray(input.bundlesList),
                timePeriod: TimePeriodBaseMapper.fromTimePeriodBaseContract(input.timePeriod),
                periodType: ReferenceDataMapper.fromReferenceDataContract(input.periodType),
                periodBundlesStatus: PeriodBundlesStatusSummaryMapper.fromPeriodDetailContract(input.periodBundlesStatus),
                lastChangedOn: {
                    date: input?.lastChangedOn,
                    timezone: timezone
                },
                lastChangedBy: input.lastChangedBy,
                totalAmount: input.totalAmount
            };
        }
        return model;
    }
}
